<template>
  <div v-if="hasPermission(permissions.reportsProperty)">
    <content-header>{{ $t("propertyReport") }}</content-header>
    <v-content>
      <h5>
        {{ $t("totalExpense") }}: {{ totalExpenses.toLocaleString() }} -
        {{ $t("totalDiscount") }}: {{ totalDiscount.toLocaleString() }}
      </h5>
      <BootstrapTable
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalRecords"
        :actions="actions"
        @on-change-query="onChangeQuery"
      >
        <template slot="empty-results">{{ $t("noResultsFound") }}</template>
        <template slot="pagination-info" slot-scope="props">
          <template v-if="props.currentPageRowsLength !== 0"
            >{{ totalRecords }} {{ $t("totalRecords") }}</template
          >
          <template v-else>{{ $t("noResultsFound") }}</template>
        </template>
        <template slot="expenses" slot-scope="props">
          {{ props.row.expenses.toLocaleString() }}
        </template>
        <template slot="discount" slot-scope="props">
          {{ props.row.discount.toLocaleString() }}
        </template>
      </BootstrapTable>
      <is-loading v-if="isLoading" />
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import IsLoading from "@/components/IsLoading";
import {
  permissions,
  serverParams,
  tableActions,
  tableConfigure,
} from "@/plugins/constants";
import BootstrapTable from "@/components/Table/BootstrapTable";
import { PropertyReport } from "@/models/PropertyReport";

export default {
  name: "PropertyReport",
  components: {
    IsLoading,
    "v-content": Content,
    ContentHeader,
    BootstrapTable,
  },
  data() {
    return {
      isLoading: false,
      model: new PropertyReport(),
      columns: [],
      rows: [],
      actions: tableActions(false),
      totalRecords: 0,
      config: tableConfigure(this.$t("propertyReport"), true, false),
      serverParams: serverParams,
      selectedRows: [],
      permissions: permissions,
      totalDiscount: 0,
      totalExpenses: 0,
    };
  },
  beforeMount() {
    this.columns = this.model.getColumns();
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData(reset = false) {
      if (reset) {
        serverParams._start = 0;
        serverParams._end = 10;
        serverParams._sort = "";
        serverParams._order = "";
        serverParams._search = "";
      }
      this.isLoading = true;
      this.serverParams.fromDate = this.fromDate;
      this.serverParams.toDate = this.toDate;
      this.$store
        .dispatch("reports/GET_PROPERTY_REPORT", this.serverParams)
        .then((response) => {
          this.rows = response.data;
          this.totalRecords = parseInt(response.headers["x-total-count"]);
          this.totalDiscount = parseInt(response.headers["mctotaldiscount"]);
          this.totalExpenses = parseInt(response.headers["mctotalexpense"]);
          this.isLoading = false;
        })
        .catch(() => (this.isLoading = false));
    },
    onChangeQuery(queryParams) {
      serverParams._start = (queryParams.page - 1) * queryParams.per_page;
      serverParams._end = queryParams.page * queryParams.per_page;
      serverParams._sort = queryParams.sort[0] ? queryParams.sort[0].name : "";
      serverParams._order = queryParams.sort[0]
        ? queryParams.sort[0].order
        : "";
      serverParams._search = queryParams.global_search ?? "";
      this.loadData();
    },
  },
};
</script>
